import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { TopNav } from './TopNav';
import { BottomTabBar } from './BottomTabBar';
import { ReferralModal } from './ReferralModal';
import './AppLayout.css';

export function AppLayout() {
  const { user, token } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  // Only show modal if user JUST signed up in this session (flag set during signup flow)
  const justSignedUp = sessionStorage.getItem('ws_just_signed_up') === 'true';
  const alreadyCompleted = localStorage.getItem('ws_referral_completed') === 'true';
  const shouldShowModal = user && justSignedUp && !alreadyCompleted && !dismissed;

  return (
    <div className="app-layout">
      <TopNav />
      <main className="app-main">
        <div className="container">
          <Outlet />
        </div>
      </main>
      <footer className="app-footer">
        <p>© 2026 Hygh Vybe · <Link to="/terms">Terms & Privacy</Link> · <Link to="/contact">Contact</Link></p>
        <p className="app-footer__seo">
          <Link to="/">Buy THC Drinks</Link> · <Link to="/">Purchase THC Beverages</Link> · <Link to="/">Find Hemp Drinks</Link> · <Link to="/">THC Seltzers</Link> · <Link to="/">Delta-9 Beverages</Link> · <Link to="/">Cannabis Drinks</Link> · <Link to="/">Hemp Beverages</Link> · <Link to="/">Buy Delta 9 THC Seltzers Online</Link>
        </p>
      </footer>
      <BottomTabBar />
      {shouldShowModal && (
        <ReferralModal token={token} onComplete={() => {
          setDismissed(true);
          sessionStorage.removeItem('ws_just_signed_up');
        }} />
      )}
    </div>
  );
}
